import { Config } from '../../_config'
import { AuthRepository } from '../domain/AuthRepository'
import { FactoryCookie } from '../../_cookie/FactoryCookie'
import { LoginStatus } from '../domain/LoginStatus'

export class CookieAuthRepository implements AuthRepository {
  static create({ config }: { config: Config }) {
    return new CookieAuthRepository(config)
  }

  constructor(private config: Config) {}

  async checkLoginStatus() {
    const cookie = await FactoryCookie.create({ config: this.config }).cookie()
    const [error] = cookie.get({ key: 'sfl_user' })

    if (error) return LoginStatus.unlogged()

    return LoginStatus.logged()
  }
}
